import type { BoxProps } from '@mui/material/Box';

import { forwardRef } from 'react';

import Box from '@mui/material/Box';

// ----------------------------------------------------------------------

export const ArGlassesIcon = forwardRef<HTMLDivElement, BoxProps>(
  (props, ref) => (
    <Box
      ref={ref}
      component="svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M3 12L5.72727 6.75C6.49091 5.6125 7.25455 5 9 5"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M21 12L18.7273 6.75C18.0909 5.6125 17.3636 5 16 5"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <line
        x1="3"
        y1="12.25"
        x2="21"
        y2="12.25"
        stroke="currentColor"
        strokeWidth="1"
      />
      <path
        d="M21.1318 12.25C21.546 12.25 21.8818 12.5858 21.8818 13V17.1543C21.8817 17.3452 21.8086 17.529 21.6777 17.668L19.9404 19.5137C19.7988 19.6641 19.6011 19.7499 19.3945 19.75H14C13.7724 19.7499 13.5573 19.6464 13.415 19.4688L12 17.7002L10.5859 19.4688C10.4436 19.6466 10.2278 19.75 10 19.75H5.10254C4.91229 19.7499 4.72871 19.6779 4.58984 19.5479L2.61914 17.7012C2.46788 17.5595 2.38196 17.3615 2.38184 17.1543V13C2.38184 12.5858 2.71762 12.25 3.13184 12.25H21.1318Z"
        stroke="currentColor"
        strokeWidth="1"
        strokeLinejoin="round"
      />
      <rect
        x="2.75"
        y="14.75"
        width="5.5"
        height="2.5"
        stroke="currentColor"
        strokeWidth="1"
      />
    </Box>
  )
);
